import { extend } from 'vee-validate'
import { required as requiredRule, email as emailRule, alpha as alphaRule } from 'vee-validate/dist/rules'

// Add the required rule
extend('required', {
  ...requiredRule,
  message: 'Ce champ est obligatoire',
})

// Add email validation rule
extend('email', {
  ...emailRule,
  message: 'Adresse email invalide',
})

// Add alpha rule
extend('alpha', {
  ...alphaRule,
  message: 'Ce champ ne peut contenir que des lettres',
})

// Add numeric rule
extend('numeric', {
  // Fix: Use Number.isNaN instead of global isNaN
  validate: value => {
    const num = Number(value)
    return !Number.isNaN(num)
  },
  message: 'Ce champ ne peut contenir que des chiffres',
})

// Add min value rule
extend('min_value', {
  validate: (value, { min }) => Number(value) >= min,
  params: ['min'],
  message: 'La valeur doit être égale ou supérieure à {min}',
})

// Add max value rule
extend('max_value', {
  validate: (value, { max }) => Number(value) <= max,
  params: ['max'],
  message: 'La valeur doit être égale ou inférieure à {max}',
})
